import { render, staticRenderFns } from "./PlayArrowOutlined.vue?vue&type=template&id=0b0c4fd4&"
import script from "./PlayArrowOutlined.vue?vue&type=script&lang=js&"
export * from "./PlayArrowOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports